import Bottombar from "@/components/bottombar"
import Button from "@/components/button"
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet"
import { Icon } from "@/icons/icon"
import { DetailSection } from "@/ipqc/components/resample-details-sheet"
import { UseFormReturn } from "@/lib/form/form"
import { ParamSchema } from "@/lib/form/schema"
import { SingleValueParamData, WindowData } from "@/lib/form/types"
import { useEffect, useState } from "react"

export interface RemarkDetailsSheetProps {
  form: UseFormReturn
}

type DetailsPayload = WindowData | SingleValueParamData

export default function RemarkDetailsSheet({ form }: RemarkDetailsSheetProps) {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState<DetailsPayload>()
  const [schema, setSchema] = useState<ParamSchema>()

  useInit()

  function useInit() {
    useEffect(() => {
      form.addEventHandler("clickShowRemarkDetails", (__event, ctx) => {
        setData(ctx.payload)
        setSchema(ctx.schema as ParamSchema)

        if (ctx.payload) {
          setOpen(true)
        } else {
          setOpen(false)
        }
      })
    }, [form])
  }

  function formatTitle(): string {
    if (!schema) {
      return "Remark"
    }

    return `${schema.name} Remark`
  }

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent
        side="bottom"
        title="Fill remarks on machine"
        className="shadow-drop-shadow rounded-t-lg"
      >
        <SheetHeader className="flex">
          <span className="size-13 flex items-center justify-center rounded-full bg-error-light">
            <Icon name="RedFlag" className="h-6 w-auto" />
          </span>

          <SheetTitle className="text-xl mt-5">{formatTitle()}</SheetTitle>
        </SheetHeader>

        <div className="px-4 pb-8">
          <DetailSection
            className="mt-0"
            field={schema?.name}
            value={data?.value}
            remark={data?.remark}
          />
        </div>

        <Bottombar className="flex gap-4 bg-white">
          <Button
            variant="default"
            className="flex-1"
            type="submit"
            onClick={() => setOpen(false)}
          >
            Go Back
          </Button>
        </Bottombar>
      </SheetContent>
    </Sheet>
  )
}
